module.exports = __webpack_public_path__ + "static/img/yuqi-state2.b3b1c787.png";